import React from "react";
import PropTypes from "prop-types";
import WidgetOptions from "../WidgetOptions";
import HighCharts from "highcharts";
import ReactDOM from "react-dom";
import NoDataDisplay from 'highcharts/modules/no-data-to-display';
import Exporting from 'highcharts/modules/exporting';
import ExportingData from 'highcharts/modules/export-data';
import {I18n} from "react-redux-i18n";
import _ from "../../../../../shared/utils/ObjectUtils";
import { TimeZoneUtils } from "../../../../../shared/utils/DateTimeUtils";

NoDataDisplay(HighCharts);
Exporting(HighCharts);
ExportingData(HighCharts);

class ChartWidget extends React.Component {
    constructor(props) {
        super(props);
        this.chartRef = null;
    }

    componentDidMount() {
        HighCharts.setOptions({
            global: {
                timezoneOffset: TimeZoneUtils.getUserTimezoneOffsetInSeconds() * -1 //offset is inversely defined in highcharts
            }
        });
        this.renderChart(this.props);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.renderChart(this.props);
    }

    renderChart(props){
        let chart = HighCharts.chart(ReactDOM.findDOMNode(this.chartRef), props.chartOptions);
        if(_.isNil(props.loading)) {
            chart.hideNoData();
            chart.showLoading();
        } else if (!props.loading && !this.hasData(props.chartOptions.series)) {
            chart.showNoData(I18n.t('dashboard.widgets.noData'));
            chart.hideLoading();
        } else if(props.loading) {
            chart.hideNoData();
            chart.showLoading();
        } else if(!props.loading) {
            chart.hideNoData();
            chart.hideLoading();
        }
    }

    hasData(series){
        let hasData = false;
        if(!series) {
            return false;
        }
        series.forEach(s => {
            if(s.data.length > 0){
                hasData = true;
            }
        });
        return hasData;
    }

    render() {
        let self = this;

        let {
            error,
            isDashboardFullScreen,
            onEditClick,
            isEditMode,
            widgetDisplayName,
            onDuplicateClicked = () => {},
            onDeleteClicked = () => {},
            onForceUpdateClick = () => {}
        } = this.props;

        return (
            <div style={{height: "100%"}} className="float-e-margins ibox widget">
                <div className="widget-options-header widget-top-corners">
                    <h5 className="widget-options-title">
                        {widgetDisplayName}
                    </h5>
                    <div className="widget-options-icons">
                        <WidgetOptions
                            widgetHasError={error}
                            isEditMode={isEditMode}
                            isDashboardFullScreen={isDashboardFullScreen}
                            showRefreshIcon={true}
                            className="widget-options-contained widget-options-effect"
                            onEditClicked={onEditClick}
                            onRefreshClicked={onForceUpdateClick}
                            onDuplicateClicked={onDuplicateClicked}
                            onDeleteClicked={onDeleteClicked}
                        />
                    </div>
                </div>
                <div className="widget-bottom-corners ibox-content-widget-full-height pd-1rem">
                    <div ref={c => self.chartRef = c}/>
                </div>
            </div>
        );
    }
}

ChartWidget.propTypes = {
    onError: PropTypes.bool,
    widgetId: PropTypes.string,
    loading: PropTypes.bool,
    chartOptions: PropTypes.any,
    widgetDisplayName: PropTypes.string,
    renderChartJumpOption: PropTypes.bool,
    tooltipMessage: PropTypes.string,
    zoomOutDescription: PropTypes.string,
    isZoomedOut: PropTypes.bool,
    onZoomOutResetClicked: PropTypes.func,
    onZoomOutClicked: PropTypes.func,
    moveChartToLeft: PropTypes.func,
    moveChartToRight: PropTypes.func,
    isEditMode: PropTypes.bool,
    isDashboardFullScreen: PropTypes.bool,
    onForceUpdateClick: PropTypes.func,
    onRefreshClicked: PropTypes.func,
    onEditClick: PropTypes.func,
    onDuplicateClicked: PropTypes.func,
    onDeleteClicked: PropTypes.func,
};

export default ChartWidget;